import React from "react";

import { LineInput } from "components/Inputs/LineInput";

import AibleStep from "containers/CreateWizard/AibleStep";

import styles from "./style.module.css";

export default class UnderstandActions extends React.PureComponent {
  render() {
    const { id, options, trueAction, falseAction, updateTrueAction, updateFalseAction } = this.props;

    const isLocked = options && options["lock"];

    return (
      <div className={styles.sliders}>
        <AibleStep
          id={id}
          message={"What will you do based on our predictions?"}
          secondaryMessage={"This will help users understand our recommendations."}
          isBreak={true}
          childStyle={{ flexDirection: "column" }}
          bId="understandActions"
        >
          <div className={styles.uInput}>
            <div className={styles.uText}>
              {"If we predict the outcome"}
              <span className={styles.bold}>{"will"}</span>
              {"happen what would you do?"}
            </div>
            <LineInput
              isMediumBox
              style={{ width: "300px" }}
              value={trueAction}
              onChange={(val) => updateTrueAction(val)}
              placeholder={"Pursue transaction"}
            />
          </div>
          <div className={styles.uInput} style={{ marginTop: "20px" }}>
            <div className={styles.uText}>
              {"If we predict the outcome"}
              <span className={styles.bold}>{"won't"}</span>
              {"happen what would you do?"}
            </div>
            <LineInput
              isMediumBox
              style={{ width: "300px" }}
              value={falseAction}
              onChange={(val) => updateFalseAction(val)}
              placeholder={"Do not pursue transaction"}
            />
          </div>
        </AibleStep>
      </div>
    );
  }
}
